
<template>
  <div class="container-fluid onboardinginput" v-bind:id="'onboardininput' + getId()" v-bind:class="element.animation">
    <div class="row mt-2" v-if="limit && step.answers && limit > step.answers.length">
      <div class="col-8">
        <input v-if="element.isEmail == true" type="email" class="form-control col-9" v-model="answer" v-bind:placeholder="element.text" style="float: left; margin-top: 7px;" required />
        <input v-if="!element.isEmail || element.isEmail == false" type="text" class="form-control col-9" v-model="answer" v-bind:placeholder="element.text" style="float: left; margin-top: 7px;" />
        <button @click="addAnswer" type="button" class="btn btn-success btn-float rounded-pill" style="float: left; margin-left:15px"><i class="fab-icon-open icon-plus3"></i></button>
      </div>
    </div>
    <div  v-show="isValid == false" class="row">
      <div class="col-8 text-left p-0">
        <label class="validationmessage">Please enter a valid email</label>
      </div>
    </div>

    <div class="row" style="margin-top:60px;" v-if="element.suggestions && element.suggestions.length > 0 && element.suggestions.length > nrOfSuggestions">
      <div class="col-12 text-center">
        <a href="#" class="suggestion-font" @click="suggest">Give me a suggestion</a>
      </div>
    </div>
  </div>
</template>

<script>

  var answer = "";
  var nrOfSuggestions = 0;
  export default {
    name: 'onboarding-input',
    components: {
    },
    props: {
      element: {
        required: false,
        type: Object,
        default() {
          return {text:''}
        }
      },
      step: {
        required: false,
        type: Object,
        default() {
          return null
        }
      },
      limit: {
        required: false,
        type: Number,
        default:10,
      },
      showresult: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        answer,
        nrOfSuggestions,
        isValid:true,
      }
    },
    methods: {
      hide() {
        $('#onboardinginput' + this.getId()).hide();
      },
      show() {
        $('#onboardinginput' + this.getId()).show();
      },
      getId() {
        return this._uid;
      },
      suggest() {
        var newSuggestion = "";
        var suggestions = this.element.suggestions;
        if (suggestions.length > this.nrOfSuggestions) {
          newSuggestion = suggestions[this.nrOfSuggestions];
          this.nrOfSuggestions = this.nrOfSuggestions + 1;
          this.answer = newSuggestion;
        }
      },
      validateEmail(email) {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      },
      addAnswer() {
        if (this.element.isEmail && this.element.isEmail == true) {
          var tmpIsValid = this.validateEmail(this.answer);
          if (!tmpIsValid) {
            this.isValid = false;
            return;
          }
        }

        this.isValid = true;

        if (this.answer == "")
          return;

        this.$emit("inputclick", this.answer, this.element, this.step)

        //if (this.element.suggestions.length == this.nrOfSuggestions) {
        //  var thisContext = this;
        //  setTimeout(function () {
        //    thisContext.$emit("goto", thisContext.element.goto)
        //  }, 3000);
        //}

        //if (this.step.answers.length == this.element.limit) {
        //  this.$emit("goto", this.element.goto)
        //}

        this.answer = "";
      }
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>
  .suggestion-font{
    font-size:18px;
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }

  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }

  .validationmessage {
    margin-top: 0px;
    margin-bottom: 0px;
    display: block;
    color: #ef5350;
    position: relative;
    padding-left: 1.625rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-input.vue